import { useSelector } from 'react-redux';

import { RouterSelectors } from '../state.js';

import { useGetCommunityProfileQuery } from './api.js';

export const useGetCurrentCommunityProfileQuery = () => {
    const communityProfileId = useSelector(RouterSelectors.communityProfileId);
    const { data: communityProfile } = useGetCommunityProfileQuery({
        screenName: communityProfileId?.length > 0 ? communityProfileId : 'me',
    });

    return {
        data: communityProfile,
    };
};
